import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const useAuthCheck = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const handleClick = () => {
      const token = sessionStorage.getItem('token');
      const expiry = sessionStorage.getItem('expiry');

      if (!token || !expiry) {
        console.log("Session missing");
        navigate('/');
        return;
      }

      const expiryDate = new Date(expiry);
      const currentDate = new Date();

      if (expiryDate < currentDate) {
        console.log("Session Expired");
        sessionStorage.clear();
        navigate('/');
        return;
      }

      console.log("Session OK");
    };

    // Attach click listener
    document.addEventListener('click', handleClick);

    // Cleanup listener on unmount
    return () => {
      document.removeEventListener('click', handleClick);
    };
  }, [navigate]);
};

export default useAuthCheck;
